module.exports = __webpack_public_path__ + "prod/1.42.2/img/guazi-icon.1020b0dc.png";